import { render, staticRenderFns } from "./pointsDetail.vue?vue&type=template&id=7dffbd26&scoped=true&"
import script from "./pointsDetail.vue?vue&type=script&lang=js&"
export * from "./pointsDetail.vue?vue&type=script&lang=js&"
import style0 from "./pointsDetail.vue?vue&type=style&index=0&id=7dffbd26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dffbd26",
  null
  
)

export default component.exports